import { Component, OnInit } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';

@Component({
    templateUrl: 'employees.html',
    standalone: false
})

export class EmployerEmployeesMockPage implements OnInit {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;
  loaded: boolean;
  rows: any;
  headers: any;

  constructor(
    private navCtrl: CustomNavController
  ) {}

  ngOnInit() {
    this.loaded = false;
    this.rows = this.buildRows();
    this.headers = this.buildHeaders();
    this.loaded = true;
  }

  buildHeaders() {
    return [
      'Employee',
      'Credit Balance',
      'Credit Used',
      'Status',
      ' '
    ];
  }

  buildRows() {
    return [
      {
        'Employee': {
          value: 'Ana Johnson',
          action: null
        },
        'Credit Balance': {
          value: '$120',
          action: null
        },
        'Credit Used': {
          value: '$70',
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      },
      {
        'Employee': {
          value: 'Brad Smith',
          action: null
        },
        'Credit Balance': {
          value: '$0',
          action: null
        },
        'Credit Used': {
          value: '$100',
          action: null
        },
        'Status': {
          value: 'Inactive',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      },
      {
        'Employee': {
          value: 'Anapaum Chari',
          action: null
        },
        'Credit Balance': {
          value: '$300',
          action: null
        },
        'Credit Used': {
          value: '$0',
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      },
      {
        'Employee': {
          value: 'Pedro Gomez',
          action: null
        },
        'Credit Balance': {
          value: '$60',
          action: null
        },
        'Credit Used': {
          value: '$60',
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      },
      {
        'Employee': {
          value: 'Monika Müller',
          action: null
        },
        'Credit Balance': {
          value: '$120',
          action: null
        },
        'Credit Used': {
          value: '$180',
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      },
      {
        'Employee': {
          value: 'Chloë Bernard',
          action: null
        },
        'Credit Balance': {
          value: '$100',
          action: null
        },
        'Credit Used': {
          value: '$360',
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      },
      {
        'Employee': {
          value: 'Sacha Martin',
          action: null
        },
        'Credit Balance': {
          value: '$100',
          action: null
        },
        'Credit Used': {
          value: '$900',
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        },
        ' ': {
          value: 'Edit',
          action: this.noAction.bind(this)
        }
      }
    ]
  }

  noAction() {
    // No action needed

  }

}
